/**
 * @file   src\pages\PaymentHistory.js
 * @brief  This file is responsible for payment history section.
 * @date   June, 2023
 * @author ZCO Engineer
 * @copyright (c) 2023, ZCO
 */
import { useState, useEffect } from "react";
import SelectDropDown from "../components/Common/SelectDropDown";
import { getPaymentHistory } from "../services/paymentsService";
import { formateDate, getUserId } from "../helpers/common";
import { PAYMENT_HISTORY_OPTIONS } from "../constants/common";

const PaymentHistory = ({ ...props }) => {
  const { currentTab } = props;
  const userId = getUserId();
  const [options, setOptions] = useState(PAYMENT_HISTORY_OPTIONS);

  const [selectedTimePeriod, setSelectedTimePeriod] = useState(options[0]);
  const [paymentHistory, setPaymenthistory] = useState([]);

  useEffect(() => {
    if (currentTab === "payments") {
      fetchPaymentHistory();
    }
  }, [selectedTimePeriod, userId, currentTab]);
  /**
   * To fetch payment history
   */
  const fetchPaymentHistory = async () => {
    const payload = {
      timePeriod: selectedTimePeriod?.value,
    };

    await getPaymentHistory(payload)
      .then((response) => {
        if (response.errorCode === 0) {
          setPaymenthistory(response?.result);
        } else {
          setPaymenthistory([]);
        }
      })
      .catch((error) => console.log(error));
  };

  const handleSelectPeriod = (selectedParam) => {
    setSelectedTimePeriod(selectedParam);
  };

  return (
    <div className="payments-wrap history-sec">
      <div className="title-sec">
        <h4>Payment history</h4>
        <div className="period">
          <p>Time period:</p>

          <SelectDropDown
            id="multi356"
            name="colors356"
            options={options}
            className="basic-single payment-select mb-0"
            classNamePrefix="select"
            value={selectedTimePeriod}
            onChange={handleSelectPeriod}
            styles={{
              dropdownIndicator: (provided, state) => ({
                ...provided,
                transform: state.selectProps.menuIsOpen && "rotate(180deg)",
              }),
            }}
            errorClass="error-msg error-msg-height d-none"
          />
        </div>
      </div>
      <div className="payment-list-sec">
        {paymentHistory.length > 0 ? (
          paymentHistory.map((paymentData) => {
            return (
              <div className="payment-data">
                <div className="payment-info">
                  {paymentData?.Is_Subs_Intro === 1 ? (
                    <p>Subscription – {paymentData?.PlanName}</p>
                  ) : (
                    <p>Introduction – {paymentData?.Location}</p>
                  )}
                  <span>
                    {formateDate(paymentData?.BillingDate, "shortMonth")}
                  </span>
                </div>
                <div className="amount">${paymentData?.Total}</div>
              </div>
            );
          })
        ) : (
          <p className="text-center mt-3">No records available</p>
        )}
      </div>
    </div>
  );
};

export default PaymentHistory;
